module.exports = __webpack_public_path__ + "img/hybrid-cloud-inf.d776093f.jpg";